/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A single logged sync run
 * @export
 * @interface WebApiAdminDtoRecentSyncRunDto
 */
export interface WebApiAdminDtoRecentSyncRunDto {
    /**
     * When the sync run was logged
     * @type {Date}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    createdAt?: Date;
    /**
     * "Fortnox" or "Spiris"
     * @type {string}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    integrationName?: string | null;
    /**
     * Company the sync ran for
     * @type {string}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    companyName?: string | null;
    /**
     * Whether the run completed without errors
     * @type {boolean}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    success?: boolean;
    /**
     * Total items synced, as logged on the History row
     * @type {number}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    itemCount?: number;
    /**
     * The sync's summary/response text, truncated
     * @type {string}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    summary?: string | null;
    /**
     * Newly created items, parsed out of Summary when present (invoice-sync runs only)
     * @type {number}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    newCount?: number | null;
    /**
     * Updated items, parsed out of Summary when present (invoice-sync runs only)
     * @type {number}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    updatedCount?: number | null;
    /**
     * Unchanged items, parsed out of Summary when present (invoice-sync runs only)
     * @type {number}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    unchangedCount?: number | null;
    /**
     * Deleted items, parsed out of Summary when present (invoice-sync runs only)
     * @type {number}
     * @memberof WebApiAdminDtoRecentSyncRunDto
     */
    deletedCount?: number | null;
}

/**
 * Check if a given object implements the WebApiAdminDtoRecentSyncRunDto interface.
 */
export function instanceOfWebApiAdminDtoRecentSyncRunDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoRecentSyncRunDtoFromJSON(json: any): WebApiAdminDtoRecentSyncRunDto {
    return WebApiAdminDtoRecentSyncRunDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoRecentSyncRunDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoRecentSyncRunDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'integrationName': !exists(json, 'integrationName') ? undefined : json['integrationName'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'success': !exists(json, 'success') ? undefined : json['success'],
        'itemCount': !exists(json, 'itemCount') ? undefined : json['itemCount'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'newCount': !exists(json, 'newCount') ? undefined : json['newCount'],
        'updatedCount': !exists(json, 'updatedCount') ? undefined : json['updatedCount'],
        'unchangedCount': !exists(json, 'unchangedCount') ? undefined : json['unchangedCount'],
        'deletedCount': !exists(json, 'deletedCount') ? undefined : json['deletedCount'],
    };
}

export function WebApiAdminDtoRecentSyncRunDtoToJSON(value?: WebApiAdminDtoRecentSyncRunDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'integrationName': value.integrationName,
        'companyName': value.companyName,
        'success': value.success,
        'itemCount': value.itemCount,
        'summary': value.summary,
        'newCount': value.newCount,
        'updatedCount': value.updatedCount,
        'unchangedCount': value.unchangedCount,
        'deletedCount': value.deletedCount,
    };
}

